export default "__VITE_ASSET__1d23e22f__"